export default ":host {\n  margin-top: 3px;\n}"